// Web app, Main module.
//

// React.
import React from 'react'
import ReactDOM from 'react-dom'

// Material UI.
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'

// Material UI theming.
import { ThemeProvider } from '@material-ui/styles'
import { CssBaseline, Typography } from '@material-ui/core'
import { createTheme, responsiveFontSizes } from '@material-ui/core/styles'

// Material UI icons.
import LocalHospitalIcon from '@material-ui/icons/LocalHospital'

// App.
import { Home } from './home'

let mainTheme = createTheme({
    palette: {
        //type: 'dark'
    }
});

mainTheme = responsiveFontSizes(mainTheme)

// Components. {
const Nav = () => {
    return (
        <AppBar position='static' color='default'>
            <Toolbar variant='dense' style={{ justifyContent: 'center' }}>
                <LocalHospitalIcon color='secondary' fontSize='large' />

                <Typography variant='h5' style={{ lineHeight: 1, marginLeft: 8 }}>PP Calc</Typography>
            </Toolbar>
        </AppBar>
    )
}

const app = () => {
    return (
        <>
            <ThemeProvider theme={ mainTheme }>
                <CssBaseline />

                <Nav />
                <Home />
            </ThemeProvider>

        </>
    )
}
// }

ReactDOM.render(app(), document.getElementById('root'))
